import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './root'

// Auth landing paths only reach the router once already signed in — send them home.
const verifyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/verify',
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})
const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})
// Anything else, signed in, falls back to the schedule.
const catchAllRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '$',
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})

export const authRoutes = [verifyRoute, loginRoute, catchAllRoute]
